import { render, staticRenderFns } from "./UlEmailField.vue?vue&type=template&id=72000e07&"
import script from "./UlEmailField.vue?vue&type=script&lang=ts&"
export * from "./UlEmailField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports